var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCalendar = function SvgIconCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.499,
    height: 16.5,
    viewBox: "0 0 16.499 16.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6393",
    "data-name": "Caminho 6393",
    d: "M14.067,16H1.931a.154.154,0,0,0-.041-.023A2.136,2.136,0,0,1,0,13.755Q0,8.591,0,3.427a2.548,2.548,0,0,1,.034-.482,2.171,2.171,0,0,1,2.2-1.759h.841c0-.191,0-.367,0-.542A.612.612,0,0,1,3.694,0,.6.6,0,0,1,4.3.649c0,.175,0,.35,0,.525h7.389c0-.063,0-.114,0-.166,0-.135,0-.271,0-.406a.6.6,0,0,1,.593-.6.606.606,0,0,1,.634.581c.01.2,0,.393,0,.605.315,0,.611,0,.907,0A2.18,2.18,0,0,1,16,3.38Q16,6.591,16,9.8c0,1.339,0,2.677,0,4.016a2.136,2.136,0,0,1-1.62,2.107c-.1.027-.207.051-.31.076m.7-9.768H1.237c0,.046-.008.082-.008.118q0,3.741,0,7.482a.953.953,0,0,0,1.036.981H13.732a1.278,1.278,0,0,0,.242-.017.954.954,0,0,0,.795-1.012q0-3.686,0-7.373ZM1.229,5.023H14.753c0-.625.024-1.239-.009-1.851a.792.792,0,0,0-.673-.751,8.025,8.025,0,0,0-1.147-.065c0,.21,0,.382,0,.553a.616.616,0,1,1-1.23,0c0-.175,0-.35,0-.523H4.3a4.153,4.153,0,0,1-.007.587.8.8,0,0,1-.165.392.569.569,0,0,1-.648.157.594.594,0,0,1-.409-.565c-.006-.19,0-.381,0-.582H2.259a.955.955,0,0,0-1.029.988c0,.333,0,.666,0,1v.663",
    transform: "translate(0.25 0.25)",
    fill: "#4b4b4b",
    stroke: "#4b4b4b",
    strokeWidth: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_calendar.8a68f106.svg";
export { ForwardRef as ReactComponent };